import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  BarController,
  PieController,
  DoughnutController,
  BubbleController,
} from "chart.js";
import {
  BUBBLE_CHART_COLOR,
  CHART_TYPE,
  DOUGHNUT_TYPE,
} from "../../utils/Constants.tsx";

import ChartDataLabels from "chartjs-plugin-datalabels";
import { numberFormatWithoutCurrency } from "../../utils/Util.tsx";
import ChartJSv2Wrapper from "./ChartJSv2Wrapper.tsx";
import BubbleChart from "./BubbleChart.tsx";

ChartJS.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PieController,
  DoughnutController,
  ArcElement,
  BubbleController,
  PointElement,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);
interface GraphProps {
  data: any;
  chartType: string;
  isLoading: boolean;
}

//plugins={data.plugins}
const getChart = (data, chartType) => {
  if (data?.data) {
    // if (chartType === CHART_TYPE.DOUGHNUT) {
    //   return <Doughnut data={data?.data} options={data?.options} />;
    // } else if (chartType === CHART_TYPE.BUBBLE) {
    //   return <Bubble options={data.options} data={data.data} />;
    // } else if (chartType === CHART_TYPE.BAR) {
    //   return <Bar options={data.options} data={data.data} />;
    // } else if (chartType === CHART_TYPE.PIE) {
    //   return <Pie options={data.options} data={data.data} />;
    // }

    return (
      <>
        {chartType === CHART_TYPE.BUBBLE && (
          <BubbleChart data={data?.data?.datasets} />
        )}
        {chartType === CHART_TYPE.DOUGHNUT && data?.data?.length > 1 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
              width: "100%",
            }}
          >
            {data.data.map((element, index) => (
              <div
                key={index}
                style={{
                  flex: "1 1 45%",
                  minWidth: "100px",
                  maxWidth: "250px",
                  maxHeight: "250px",
                  padding: "10px",
                }}
              >
                <React.Fragment key={index}>
                  <ChartJSv2Wrapper
                    type={chartType}
                    data={element}
                    options={data?.options}
                  />
                </React.Fragment>
              </div>
            ))}
          </div>
        ) : (
          <ChartJSv2Wrapper
            type={chartType}
            data={data?.data}
            options={data?.options}
          />
        )}
      </>
    );
  }
};
const NocChart = ({ data, chartType, isLoading }: GraphProps) => {
  return (
    <>
      {data?.data && (
        <div>
          <span className="noc-chart-title">{data?.chartTitle || "--"}</span>
          {chartType !== CHART_TYPE.BUBBLE && (
            <div className="mt-2 chart-style" style={{ height: "32vh" }}>
              {getChart(data, chartType)}
            </div>
          )}

          {chartType === CHART_TYPE.DOUGHNUT && data?.chartTitle !== "Product wise Pending and Processed claims" && (
            <div className="doughnut-center-text">
              <div>{data?.centerText}</div>
              <div>{data?.centerSubText}</div>
            </div>
          )}
          {chartType === CHART_TYPE.DOUGHNUT && data?.chartTitle == "Product wise Pending and Processed claims" && (
            <>
              <div className="doughnut-center-text1">
                <div>{data?.centerText2}</div>
                <div>Processed</div>
              </div>
              <div className="doughnut-center-text2">
                <div>{data?.centerText}</div>
                <div>Pending </div>
              </div>
            </>
          )}
          {chartType === CHART_TYPE.BUBBLE && data?.labels && (
            <>
              <div className="mt-2 chart-style" style={{ height: "22vh" }}>
                {getChart(data, chartType)}
              </div>
              <div className="row">
                {data?.labels.map((item, index) => (
                  <div key={item.id} className="col-12 col-md-6 d-flex">
                    <div
                      className="circle"
                      style={{ backgroundColor: BUBBLE_CHART_COLOR[index] }}
                    ></div>
                    <div className="crop-legend">{item.split("/")[0]} </div>
                    <div className="ms-auto crop-legend me-4">
                      {" "}
                      {numberFormatWithoutCurrency(data?.dataTotal[index])}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}
      {!data?.data && (
        <div className="d-flex justify-content-center">
          <div className="no-chart">{isLoading ? "Loading..." : ""}</div>
        </div>
      )}
    </>
  );
};
export default NocChart;
